import {
	requestGenerateContentTemplates,
	requestGeneratedContent,
	requestGeneratedContentById,
	requestDeleteGeneratedContentById,
	upsertContentRequest,
	getDraftEntities,
	upsertAssociatedContentRequest,
} from '../../connection/generate-content';
import { Meeting } from '../types/session';
import { GeneratedContent, GeneratedContentData } from '../types/content';
import { GraphicInterface } from '../types/graphics';
import { MediaItem } from '../types/media';
import { EntityType } from '../../types/enums';

export const CONTENT_ENTITY_UPDATED = EntityType.generatedContent;
export const CONTENT_ENTITY_UPDATED_DRAFT = `${EntityType.generatedContent}-edit`;

export const LOAD_GENERATE_CONTENT_TEMPLATES = 'LOAD_GENERATE_CONTENT_TEMPLATES';
export function loadGenerateContentTemplates(token: string) {
	return {
		type: LOAD_GENERATE_CONTENT_TEMPLATES,
		promise: requestGenerateContentTemplates(token),
	};
}

export const LOAD_GENERATED_CONTENT = 'LOAD_GENERATED_CONTENT';
export function loadGeneratedContent(token: string, meeting: Meeting) {
	return {
		type: LOAD_GENERATED_CONTENT,
		promise: requestGeneratedContent(token, meeting),
	};
}

export const LOAD_GENERATED_CONTENT_BY_ID = 'LOAD_GENERATED_CONTENT_BY_ID';
export function loadGeneratedContentById(token: string, meeting: Meeting, id: number) {
	return {
		type: LOAD_GENERATED_CONTENT_BY_ID,
		promise: requestGeneratedContentById(token, meeting, id),
	};
}

export const REMOVE_GENERATED_CONTENT_BY_ID = 'REMOVE_GENERATED_CONTENT_BY_ID';
export function removeGeneratedContentById(token: string, meeting: Meeting, id: number) {
	return {
		type: REMOVE_GENERATED_CONTENT_BY_ID,
		promise: requestDeleteGeneratedContentById(token, meeting, id),
	};
}

export const UPSERT_CONTENT = 'UPSERT_CONTENT';
export function upsertContent(
	token: string,
	roomId: number,
	userId: number,
	associated: GraphicInterface | MediaItem,
	generated: GeneratedContent,
	initialChipUser?: number
) {
	return {
		type: UPSERT_CONTENT,
		promise: upsertContentRequest(token, roomId, userId, associated, generated, initialChipUser),
		payload: generated,
	};
}

export const UPSERT_ASSOCIATED_CONTENT = 'UPSERT_ASSOCIATED_CONTENT';
export function upsertAssociatedContent(
	token: string,
	roomId: number,
	userId: number,
	associated: GraphicInterface | MediaItem,
	shotId?: number,
	skipThumbnailRegen?: boolean,
) {
	return {
		type: UPSERT_ASSOCIATED_CONTENT,
		promise: upsertAssociatedContentRequest(token, roomId, userId, associated, shotId, skipThumbnailRegen),
		payload: associated,
	};
}

export const LOAD_DRAFT_CONTENT = 'LOAD_DRAFT_CONTENT';
export function loadDraftContent(token: string, meeting: number) {
	return {
		type: LOAD_DRAFT_CONTENT,
		promise: getDraftEntities(token, meeting, EntityType.generatedContent),
	};
}

export const CLEAR_DRAFT_CONTENT = 'CLEAR_DRAFT_CONTENT';
export function clearDraftContent() {
	return {
		type: CLEAR_DRAFT_CONTENT,
		payload: null,
	};
}

export const SET_SELECTED_MEDIA_TEMPLATE = 'SET_SELECTED_MEDIA_TEMPLATE';
export function setSelectedMediaTemplate(mediaItem: MediaItem | null, template: string) {
	return {
		type: SET_SELECTED_MEDIA_TEMPLATE,
		payload: {
			mediaItem,
			template,
		},
	};
}

export const SET_STYLE_PACK_DRAWER = 'SET_STYLE_PACK_DRAWER';
export function setStylePackDrawer(drawer: 'style-packs' | 'style-pack-info') {
	return {
		type: SET_STYLE_PACK_DRAWER,
		payload: drawer,
	};
}

export const ADD_INITIALIZING_JOB = 'ADD_INITIALIZING_JOB';
export function addInitializingJob(key: string, data: GeneratedContentData[], version: number) {
	return {
		type: ADD_INITIALIZING_JOB,
		payload: {
			key,
			data,
			version,
		},
	};
}

export const REMOVE_INITIALIZING_JOB = 'REMOVE_INITIALIZING_JOB';
export function removeInitializingJob(key: string) {
	return {
		type: REMOVE_INITIALIZING_JOB,
		payload: key,
	};
}
